import React from 'react';
import classNames from 'classnames';
import TextExtended from '../components/text-extended/text-extended';
import { useTranslate } from '../context/api-context/translations/use-translate';
import styles from './list-fetch-error-state.scss';
import { Button } from 'wix-ui-tpa';
import { LIST_FETCH_ERROR } from '../../common/constants/data-hooks';
const ListFetchErrorState = ({ onRetry }) => {
    const t = useTranslate();
    return (React.createElement("div", { "data-hook": LIST_FETCH_ERROR, className: classNames(styles.container, 'wc-separator-color') },
        React.createElement("div", { className: styles.text },
            React.createElement(TextExtended, { priority: "primary" }, t('empty-state.list-fetch-error'))),
        React.createElement("div", { className: styles.text },
            React.createElement(TextExtended, { priority: "secondary" }, t('empty-state.list-fetch-error-subtext'))),
        React.createElement("div", { className: styles.buttonContainer },
            React.createElement(Button, { onClick: onRetry }, t('empty-state.list-fetch-error-try-again')))));
};
export default ListFetchErrorState;
//# sourceMappingURL=list-fetch-error-state.js.map